import * as Yup from 'yup';
import { getValidationRules } from '../../utils/validation';
// @ts-ignore
import calculator from './content.json';

export const validation = Yup.object().shape({
  ...getValidationRules(calculator)
});
